import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import * as Sentry from '@sentry/browser';
import * as serviceWorker from './serviceWorker'
import configAPI from './utilities/api/config'
import renderHTML from 'react-render-html'
import { getCCPAxios, getSiteAxios } from './utilities/function/axios'

window.dataLayer = window.dataLayer || [];

window.siteAxios = getSiteAxios()

const { getAppConfig } = configAPI
getAppConfig().then(response => {
  const { data } = response
  if(data && data.app_color_css && data.app_config){
    const {app_color_css,app_config} = data
    window.app_config = app_config
    window.ccpAxios = getCCPAxios()
    const $style = document.createElement('style')
    $style.innerHTML = renderHTML(app_color_css)
    document.head.appendChild($style)

    ReactDOM.render(<App app_config={app_config}/>, document.getElementById('ordering-form-root'))

    //check if sentry dns has value

    if(app_config && app_config.sentry_link){

      Sentry.init({
        dsn: app_config.sentry_link,
        integrations(integrations) {
          return integrations.filter(integration => integration.name !== 'Breadcrumbs');
        },
        ignoreErrors: ['ResizeObserver loop limit exceeded']
      });
    }
  }
}, error => {
  console.log(error)
})






// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
